import React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
	highlight: {
		// color: "#fff",
		fontWeight: "bold",
		backgroundColor: "#eef43b"
	}
}));

const HighlightText = ({ text, searchText, exactMatch = false }) => {
	const classes = useStyles();
	const shouldHighlight = exactMatch ? searchText === text : true;

	const getTextWithHighlights = () => {
		const regex = new RegExp(searchText, "gi");
		const highlighted = `<mark class=${classes.highlight}>$&</mark>`;
		const newText = text ? text.replace(regex, highlighted) : text;

		// eslint-disable-next-line react/no-danger
		return <span dangerouslySetInnerHTML={{ __html: `${newText}&nbsp;` }} />;
	};

	const getText = () => {
		return shouldHighlight ? getTextWithHighlights() : `${text} `;
	};

	return getText();
};

export default HighlightText;
